import { FieldType, InputFormatType, TransactionSide } from '@common/enums';
import {
  DarwinEnabledNormalizedFields,
  DarwinFieldMapping,
  NORMALIZED_FIELD_TO_DARWIN_FIELDS,
} from './darwin.fields';

/**
 * Gets Darwin field mappings for a given normalized field key,
 * with transaction-side awareness for commission fields.
 *
 * For SELL-side transactions, buyer broker compensation fields are remapped:
 * - buyer_broker_compensation_total_percent → cobrokeCommRate
 * - buyer_broker_compensation_total → cobrokeCommission
 *
 * @param fieldKey - The normalized field key (e.g., 'purchase_price')
 * @param transactionSide - Optional transaction side for context-aware mapping
 * @returns Array of Darwin field mappings for the given field
 */
export function getDarwinFieldMappings(
  fieldKey: DarwinEnabledNormalizedFields,
  transactionSide?: TransactionSide | null
): DarwinFieldMapping[] {
  const darwinFieldMappings = NORMALIZED_FIELD_TO_DARWIN_FIELDS[fieldKey];

  if (!darwinFieldMappings) {
    return [];
  }

  // For SELL-side transactions, buyer broker compensation should map to cobroke fields
  // instead of sell fields (BLO-3063)
  if (
    transactionSide === TransactionSide.SELL &&
    fieldKey ===
      DarwinEnabledNormalizedFields.BUYER_BROKER_COMPENSATION_TOTAL_PERCENT
  ) {
    return [
      {
        label: 'Cobroke Commission Rate',
        darwinKey: 'cobrokeCommRate',
        fieldType: FieldType.NUMBER,
        inputFormat: { type: InputFormatType.PERCENTAGE },
      },
    ];
  } else if (
    transactionSide === TransactionSide.SELL &&
    fieldKey === DarwinEnabledNormalizedFields.BUYER_BROKER_COMPENSATION_TOTAL
  ) {
    return [
      {
        label: 'Cobroke Commission Amount',
        darwinKey: 'cobrokeCommission',
        fieldType: FieldType.NUMBER,
        inputFormat: { type: InputFormatType.CURRENCY },
      },
    ];
  }

  return darwinFieldMappings;
}
